// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-toolbar[data-v-1a4b33c4] {\n  padding-top: env(safe-area-inset-top) !important;\n  height: calc(env(safe-area-inset-top) + 48px) !important;\n}", ""]);
// Exports
module.exports = exports;
